import React from 'react'
import { CircularProgress, styled } from '@mui/material'

const Container = styled('div')`
    margin-right: 12px;
`

export const CircularProgressSelectDropdown: React.VFC = () => (
    <Container>
        <CircularProgress size={14} />
    </Container>
)
